import {
  doc, updateDoc, addDoc, collection,
} from 'firebase/firestore';
import { db } from '../../lib/firebase';

// Edit a hub's location / coverage (owner/HQ per rules). This is "how you move hubs".
export function updateStore(storeId, patch, actor) {
  return updateDoc(doc(db, 'stores', storeId), {
    ...patch,
    updatedBy: actor?.uid ?? null,
    updatedAt: Date.now(),
  });
}

// Add a new hub (owner/HQ; tenantId must be in scope per rules).
export function createStore({
  tenantId, name, address, lat, lng, radiusKm,
}, actor) {
  const now = Date.now();
  return addDoc(collection(db, 'stores'), {
    tenantId,
    name: name ?? '',
    address: address ?? '',
    lat: lat != null && lat !== '' ? Number(lat) : null,
    lng: lng != null && lng !== '' ? Number(lng) : null,
    radiusKm: radiusKm != null && radiusKm !== '' ? Number(radiusKm) : null,
    status: 'active',
    createdBy: actor?.uid ?? null,
    createdAt: now,
    updatedAt: now,
  });
}
